export const VIDEO_LIBRARY = 'VIDEO_LIBRARY' as const;
export const IMAGE_LIBRARY = 'IMAGE_LIBRARY' as const;
